import { ReactComponent as EmptyIcon } from '@Icons/additional/no-data.svg';
import { Flex } from 'antd';

import styles from './material-empty.module.css';

const MaterialEmptyScreen: React.FC<{ text: string }> = ({ text = '' }) => {
  return (
    <Flex vertical className={styles.container}>
      <EmptyIcon />
      <div className={styles.textContainer}>
        <span className={styles.caption}>No Data</span>
        <span className={styles.description}>{text}</span>
      </div>
    </Flex>
  );
};

export default MaterialEmptyScreen;
